import {
  ADD_BLOCK_FAILURE,
  ADD_BLOCK_REQUEST,
  ADD_BLOCK_SUCCESS,
  DELETE_BLOCK_FAILURE,
  DELETE_BLOCK_REQUEST,
  DELETE_BLOCK_SUCCESS,
  FETCH_BLOCK_FAILURE,
  FETCH_BLOCK_REQUEST,
  FETCH_BLOCK_SUCCESS,
  FETCH_LIST_ALL_BLOCK_FAILURE,
  FETCH_LIST_ALL_BLOCK_REQUEST,
  FETCH_LIST_ALL_BLOCK_SUCCESS,
  FETCH_LIST_BLOCK_FAILURE,
  FETCH_LIST_BLOCK_REQUEST,
  FETCH_LIST_BLOCK_SUCCESS,
  RESET_CURRENT_BLOCK,
  UPDATE_BLOCK_FAILURE,
  UPDATE_BLOCK_REQUEST,
  UPDATE_BLOCK_SUCCESS,
} from "./blockType";

export const fetchAllBlocks = (pageNo) => ({
  type: FETCH_LIST_ALL_BLOCK_REQUEST,
  payload: pageNo,
});

export const fetchAllBlocksSuccess = (blocks) => ({
  type: FETCH_LIST_ALL_BLOCK_SUCCESS,
  payload: { blocks },
});

export const fetchAllBlocksFailure = (error) => ({
  type: FETCH_LIST_ALL_BLOCK_FAILURE,
  payload: { error },
});

export const fetchBlocks = () => ({
  type: FETCH_LIST_BLOCK_REQUEST,
});

export const fetchBlocksSuccess = (blocks) => ({
  type: FETCH_LIST_BLOCK_SUCCESS,
  payload: { blocks },
});

export const fetchBlocksFailure = (error) => ({
  type: FETCH_LIST_BLOCK_FAILURE,
  payload: { error },
});

export const fetchBlock = (blockId) => ({
  type: FETCH_BLOCK_REQUEST,
  payload: { blockId },
});

export const fetchBlockSuccess = (blocks) => ({
  type: FETCH_BLOCK_SUCCESS,
  payload: { blocks },
});

export const fetchBlockFailure = (error) => ({
  type: FETCH_BLOCK_FAILURE,
  payload: { error },
});

export const addBlock = (blockData) => ({
  type: ADD_BLOCK_REQUEST,
  payload: { blockData },
});

export const addBlockSuccess = (block) => ({
  type: ADD_BLOCK_SUCCESS,
  payload: { block },
});

export const addBlockFailure = (error) => ({
  type: ADD_BLOCK_FAILURE,
  payload: { error },
});

export const updateBlock = (blockId, blockData) => {
  return {
    type: UPDATE_BLOCK_REQUEST,
    payload: { blockId, blockData },
  };
};

export const updateBlockSuccess = (block) => ({
  type: UPDATE_BLOCK_SUCCESS,
  payload: { block },
});

export const updateBlockFailure = (error) => ({
  type: UPDATE_BLOCK_FAILURE,
  payload: { error },
});

export const deleteBlock = (blockId) => {
  return {
    type: DELETE_BLOCK_REQUEST,
    payload: { blockId },
  };
};
export const deleteBlockSuccess = (blockId) => ({
  type: DELETE_BLOCK_SUCCESS,
  payload: { blockId },
});

export const deleteBlockFailure = (error) => ({
  type: DELETE_BLOCK_FAILURE,
  payload: { error },
});

export const resetCurrentBlock = () => ({
  type: RESET_CURRENT_BLOCK,
});
